module.exports = __webpack_public_path__ + "assets/img/facebook_1024.4cbc9013.png";